import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23562a74&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=23562a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23562a74",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/app/components/page/header.vue').default,UiTransition: require('/app/components/ui/transition.vue').default,UiIcon: require('/app/components/ui/icon.vue').default,UiScrollContainer: require('/app/components/ui/scroll-container.vue').default,UiTagline: require('/app/components/ui/tagline.vue').default,FormsContact: require('/app/components/forms/contact.vue').default})
